import { call, put, select, takeEvery } from 'redux-saga/effects'

import { EventTrackingNames } from '@enums'
import { IHateoasLink } from '@store'
import { selectCampaignTrackingProps, trackEvent } from '@store/analytics'
import { selectAuthToken } from '@store/auth'
import {
  downloadInstagramHandles,
  InstagramHandlesActionTypes,
  selectDownloadInstagramHandlesLink,
} from '@store/campaigns'
import { selectApprovedSubmissionsCount } from '@store/submissions'
import { downloadCSV } from '@utils'

export function* handleDownloadInstagramHandles(
  action: ReturnType<typeof downloadInstagramHandles>,
) {
  const { campaignId, fileName } = action.payload
  const authToken: string = yield select(selectAuthToken)
  const downloadLink: IHateoasLink = yield select(selectDownloadInstagramHandlesLink, campaignId)

  const headers = {
    Authorization: `Bearer ${authToken}`,
  }

  try {
    yield call(downloadCSV, downloadLink, fileName, headers)
  } catch {
    // BRAND-9636 I3: downloadCSV now throws on a non-ok response instead of
    // silently saving the error body as a CSV. That's a genuine improvement,
    // but this saga has no try/catch of its own, so a 500 here used to abort
    // it mid-flight and the analytics event below never fired — a regression
    // from its pre-existing behaviour of firing unconditionally. Swallow the
    // failure here so the event still fires.
  }

  const campaignProps = yield select(selectCampaignTrackingProps, campaignId)
  const count = yield select(selectApprovedSubmissionsCount, campaignId)
  yield put(trackEvent(EventTrackingNames.DownloadInstagramHandlesCSV, { ...campaignProps, count }))
}

export function* watchDownloadInstagramHandles() {
  yield takeEvery(InstagramHandlesActionTypes.DOWNLOAD_CSV, handleDownloadInstagramHandles)
}
